export const en = {
  changePassword: "Change Password",
  passwordConf: "New Password Confirmation",
  errorText: {
    oops: "Oops. Looks like that link is expired.",
    sendNew: "Click here to send a new link.",
    invalidLink: "Invalid link",
  },
};
